// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/social-feeds/social-feeds.component.scss
// module id = 564
// module chunks = 0